/** 响应式国际化 composable — 从 Pinia locale store 读取语言，按 key 翻译 */
import { computed } from 'vue'
import { useLocaleStore } from '@/stores/locale'
import { zhCN } from '@/locales/zh-CN'
import { en } from '@/locales/en'

const locales: Record<string, Record<string, string>> = {
  'zh-CN': zhCN,
  'en': en,
}

type TranslationParams = Record<string, string | number>

export function translate(
  locale: string,
  key: string,
  params: TranslationParams = {},
  fallback = key,
): string {
  const template = (locales[locale] || zhCN)[key] || zhCN[key] || fallback
  return template.replace(/\{(\w+)\}/g, (_, name: string) => String(params[name] ?? `{${name}}`))
}

export function useLocale() {
  const store = useLocaleStore()

  const locale = computed(() => store.locale)

  /** 翻译函数：t('settings.title') → "系统设置" / "System Settings" */
  function t(key: string, params: TranslationParams = {}, fallback = key): string {
    return translate(locale.value, key, params, fallback)
  }

  return { locale, t }
}
